module.exports = __webpack_public_path__ + "img/Texture_Yellow-Top.7b4cafc4.svg";